import "./RefundPolicy.module.css";
import Header from "@/reusable_sections/Header";
import RefundPolicyText from "./sections/RefundPolicyText";
import Footer from "@/reusable_sections/Footer";
export default function RefundPolicyPage() {
  return <div>
      <Header />
      <RefundPolicyText />
      <Footer />
    </div>;
}